// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
   height: 3px;
   margin-top: 1em;
   opacity: 0;
}
.visible { opacity: 1 }
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/confirm-permanent-delete/confirm-permanent-delete.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,eAAe;GACf,UAAU;AACb;AACA,WAAW,WAAW;AACtB;GACG,wBAAwB;AAC3B","sourcesContent":[".progress {\n   height: 3px;\n   margin-top: 1em;\n   opacity: 0;\n}\n.visible { opacity: 1 }\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
